/* @flow */
import Entity from 'lib/Entity';
import apiRequest from 'lib/apiRequest';
import User from 'entities/User';

export default class Session extends Entity {
  initialize() {
    this.url = '/sessions';
  }

  isNew() {
    return false;
  }

  static create(email, password, persist = false): Promise<User> {
    return apiRequest('/sessions', 'POST', {
      user: {
        email,
        password,
      },
      persist,
    }).then(user => User.fromJSON(user));
  }

  static createWithToken(token): Promise<User> {
    return apiRequest('/sessions', 'POST', {
      auth_token: token,
    }).then(user => User.fromJSON(user));
  }

  static createWithGoogleAuthorizationCode(code): Promise<User> {
    return apiRequest('/users/auth/google_plus/callback', 'POST', {
      code,
    }, false).then(response => User.fromJSON(response.user));
  }

  static destroy() {
    return (new Session()).destroy();
  }
}



// WEBPACK FOOTER //
// ./src/entities/Session.js